import Vue from 'vue'
import {mutationTypes} from '@/commons/constants'

Vue.mixin({
    methods: {
        criarLinkDownload(uri, thumbnail) {
            return `${this.$store.state.loki.file.api}?uri=${uri}&thumbnail=${thumbnail === true}`
        },
        criarLinkDownloadTemporario(uri, thumbnail) {
            return `${this.$store.state.loki.file.api}/temporario?uri=${uri}&thumbnail=${thumbnail === true}`
        },
        setApiArquivos(api) {
            this.$store.commit(mutationTypes.SET_FILES_API, api)
        },
        resetUploadedFiles() {
            this.$store.commit('SET_UPLOADED_FILES', [])
        },
        setUploadedFiles(files){
            this.$store.commit('SET_UPLOADED_FILES', files)
        },
        async uploadFile(payload) {
            return await this.$store.dispatch('uploadFile', payload)
        }
    }
})
